module.exports = __webpack_public_path__ + "static/media/output.863f64b2.mp3";